var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLedIndicator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_radial)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6126 32.9071C52.6126 33.6458 52.1201 34.1383 51.3813 34.1383H48.9188C48.18 34.1383 47.6875 33.6458 47.6875 32.9071V23.0569C47.6875 22.3182 48.18 21.8257 48.9188 21.8257H51.3813C52.1201 21.8257 52.6126 22.3182 52.6126 23.0569V32.9071Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6775 36.1084L69.6025 27.6126C69.9719 26.997 70.7107 26.8739 71.3263 27.1201L73.4194 28.3514C74.0351 28.7208 74.1582 29.4595 73.9119 30.0752L68.9869 38.5709C68.6175 39.1865 67.8787 39.3097 67.2631 39.0634L65.17 37.8321C64.5543 37.4628 64.3081 36.724 64.6775 36.1084Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4345 38.5709L26.5095 30.0752C26.1401 29.4595 26.3864 28.7208 27.002 28.3514L29.0951 27.1201C29.7108 26.7508 30.4495 26.997 30.6958 27.6127L35.6208 36.1084C35.9902 36.724 35.744 37.4628 35.1283 37.8322L33.0352 39.0634C32.5427 39.4328 31.8039 39.1865 31.4345 38.5709Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1071 51.6223L11.6114 46.6972C10.9958 46.451 10.8727 45.5891 11.1189 45.0966L12.3502 43.0034C12.7196 42.3878 13.4583 42.2647 14.0739 42.5109L22.5697 47.436C23.1853 47.8054 23.3084 48.5441 23.0622 49.1598L21.8309 51.2529C21.4615 51.7454 20.7228 51.9917 20.1071 51.6223Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7286 47.436L86.2243 42.511C86.84 42.1416 87.5787 42.3878 87.9481 43.0035L89.1794 45.0966C89.5487 45.7122 89.3025 46.451 88.6869 46.8204L80.1911 51.7454C79.5755 52.1148 78.8367 51.8686 78.4674 51.2529L77.2361 49.1598C76.9898 48.5442 77.113 47.6823 77.7286 47.436Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2863 60.7337H74.0368C74.0368 60.6105 73.9137 60.3643 73.9137 60.2412C71.328 49.1598 61.4779 41.5259 50.1502 41.5259C38.8226 41.5259 28.9725 49.2829 26.3868 60.3643C26.3868 60.6105 26.2637 60.7337 26.2637 60.8568H18.1374C17.5217 60.7337 17.1523 61.2262 17.1523 61.7187V65.2894C17.1523 65.7819 17.5217 66.2744 18.1374 66.2744H25.7712H74.5293H82.2863C82.7788 66.2744 83.2713 65.905 83.2713 65.2894V61.7187C83.1481 61.2262 82.7788 60.7337 82.2863 60.7337ZM50.1502 46.2047C59.1385 46.2047 66.8954 52.2379 69.2349 60.8568H31.0656C33.405 52.1148 41.162 46.2047 50.1502 46.2047Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45) scale(141.421 171.504)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DD0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F80ED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedIndicator);
export default __webpack_public_path__ + "static/media/LEDIndicator.39c509f150a029705cbf55fee505db73.svg";
export { ForwardRef as ReactComponent };